import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "page-inner" }
const _hoisted_2 = { class: "stat-inner" }
const _hoisted_3 = { class: "stat-icon stat-icon-blue" }
const _hoisted_4 = { class: "stat-info" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "stat-label" }, "日志总数", -1)
const _hoisted_6 = { class: "stat-value stat-value-sm" }
const _hoisted_7 = { class: "stat-inner" }
const _hoisted_8 = { class: "stat-icon stat-icon-green" }
const _hoisted_9 = { class: "stat-info" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "stat-label" }, "收入日志", -1)
const _hoisted_11 = { class: "stat-value stat-value-sm" }
const _hoisted_12 = { class: "stat-inner" }
const _hoisted_13 = { class: "stat-icon stat-icon-orange" }
const _hoisted_14 = { class: "stat-info" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "stat-label" }, "支出日志", -1)
const _hoisted_16 = { class: "stat-value stat-value-sm" }
const _hoisted_17 = { class: "card-title-row" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "card-title-text" }, "操作日志记录", -1)
const _hoisted_19 = {
  key: 0,
  class: "log-card-list"
}
const _hoisted_20 = { class: "mobile-card-head" }
const _hoisted_21 = { class: "mobile-card-title" }
const _hoisted_22 = { class: "mobile-id" }
const _hoisted_23 = { class: "mobile-time" }
const _hoisted_24 = { class: "mobile-card-body" }
const _hoisted_25 = { class: "mobile-field" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", { class: "mobile-label" }, "内容", -1)
const _hoisted_27 = { class: "mobile-value" }
const _hoisted_28 = { class: "mobile-field" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("span", { class: "mobile-label" }, "操作金额", -1)
const _hoisted_30 = { class: "mobile-field" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("span", { class: "mobile-label" }, "交易前", -1)
const _hoisted_32 = { class: "mobile-field" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("span", { class: "mobile-label" }, "交易后", -1)
const _hoisted_34 = { class: "table-pagination" }

import UserHead from '@/components/UserHead.vue';
import HeadTop from '@/components/UserHeadTop.vue';
import { ref, onMounted, computed } from 'vue';
import { openLoading, fullscreenLoading } from '@/utils/loadingUtils';
import axios from 'axios';
import { message } from 'ant-design-vue';
import {
    FileTextOutlined,
    ArrowUpOutlined,
    ArrowDownOutlined,
} from '@ant-design/icons-vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'UserLog',
  setup(__props) {

const baseURL = process.env.VUE_APP_API_BASE_URL;

// 日志分页配置
const log_Conf = ref({
    currentPage: 1,
    pageSize: 10,
    total: 0,
});

// 日志数据
const log_data = ref<any[]>([]);

// 加载状态
const log_loading = ref(false);

// 日志类型转文字
const getLogAct = (act: number): string => {
    switch (act) {
        case 1:
            return '收入';
        case 2:
            return '支出';
        case 3:
            return '登录';
        case 4:
            return '其他';
        case 5:
            return '作者收入';
        default:
            return '未知';
    }
};

// 日志类型对应 a-tag 颜色
const getLogTagColor = (act: number): string => {
    switch (act) {
        case 1:
            return 'green';
        case 2:
            return 'red';
        case 3:
            return 'blue';
        case 4:
            return 'default';
        case 5:
            return 'cyan';
        default:
            return 'default';
    }
};

// 统计收入日志数量
const incomeCount = computed(() => {
    return log_data.value.filter(item => item.log_act === 1 || item.log_act === 5).length;
});

// 统计支出日志数量
const expenseCount = computed(() => {
    return log_data.value.filter(item => item.log_act === 2).length;
});

// 表格列配置
const logColumns = [
    { title: 'ID', dataIndex: 'id', key: 'id', width: 60, align: 'center' as const },
    { title: '日志类型', dataIndex: 'log_act', key: 'log_act', width: 100, align: 'center' as const },
    { title: '内容', dataIndex: 'log_desc', key: 'log_desc', ellipsis: true },
    { title: '交易后余额', dataIndex: 'afterMoney', key: 'afterMoney', width: 120, align: 'right' as const },
    { title: '交易前余额', dataIndex: 'beforeMoney', key: 'beforeMoney', width: 120, align: 'right' as const },
    { title: '操作金额', dataIndex: 'operationMoney', key: 'operationMoney', width: 120, align: 'right' as const },
    { title: '时间', dataIndex: 'add_time', key: 'add_time', width: 170, align: 'center' as const },
];

// 获取用户日志
const getUserLog = () => {
    openLoading();
    log_loading.value = true;
    const data = new FormData();
    data.append('page', String(log_Conf.value.currentPage));
    data.append('pageSize', String(log_Conf.value.pageSize));
    const headers = {
        token: localStorage.getItem('token'),
    };
    axios
        .post(baseURL + '/userApi/getUserLog', data, { timeout: 30000, headers })
        .then(res => {
            if (res.data.code == 401) {
                message.error(res.data.msg);
                setTimeout(() => {
                    location.href = '/Login';
                }, 1000);
                return;
            }
            if (res.data.code == 200) {
                log_data.value = res.data.data;
                log_Conf.value.total = res.data.total;
                return;
            } else {
                message.error(res.data.msg);
            }
        })
        .catch(err => {
            message.error(err.message || '请求失败');
        })
        .finally(() => {
            fullscreenLoading.close();
            log_loading.value = false;
        });
};

// 分页变化
const pageChange = (page: number, pageSize: number) => {
    log_Conf.value.currentPage = page;
    log_Conf.value.pageSize = pageSize;
    getUserLog();
};

onMounted(() => {
    getUserLog();
});

return (_ctx: any,_cache: any) => {
  const _component_a_layout_header = _resolveComponent("a-layout-header")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_empty = _resolveComponent("a-empty")!
  const _component_a_pagination = _resolveComponent("a-pagination")!
  const _component_a_layout_content = _resolveComponent("a-layout-content")!
  const _component_a_layout = _resolveComponent("a-layout")!

  return (_openBlock(), _createBlock(_component_a_layout, { style: {"min-height":"100vh"} }, {
    default: _withCtx(() => [
      _createVNode(UserHead),
      _createVNode(_component_a_layout, null, {
        default: _withCtx(() => [
          _createVNode(_component_a_layout_header, { style: {"padding":"0","background":"#fff","border-bottom":"1px solid #f0f0f0"} }, {
            default: _withCtx(() => [
              _createVNode(HeadTop)
            ]),
            _: 1
          }),
          _createVNode(_component_a_layout_content, {
            class: "page-content",
            style: {"padding":"24px","background":"#f5f7fa"}
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_a_row, {
                  gutter: [16, 16],
                  class: "stat-row"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, {
                      xs: 12,
                      sm: 8,
                      md: 8
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_card, {
                          class: "stat-card",
                          bordered: false
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_2, [
                              _createElementVNode("div", _hoisted_3, [
                                _createVNode(_unref(FileTextOutlined))
                              ]),
                              _createElementVNode("div", _hoisted_4, [
                                _hoisted_5,
                                _createElementVNode("div", _hoisted_6, _toDisplayString(log_Conf.value.total), 1)
                              ])
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_col, {
                      xs: 12,
                      sm: 8,
                      md: 8
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_card, {
                          class: "stat-card",
                          bordered: false
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_7, [
                              _createElementVNode("div", _hoisted_8, [
                                _createVNode(_unref(ArrowUpOutlined))
                              ]),
                              _createElementVNode("div", _hoisted_9, [
                                _hoisted_10,
                                _createElementVNode("div", _hoisted_11, _toDisplayString(incomeCount.value), 1)
                              ])
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_col, {
                      xs: 12,
                      sm: 8,
                      md: 8
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_card, {
                          class: "stat-card",
                          bordered: false
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_12, [
                              _createElementVNode("div", _hoisted_13, [
                                _createVNode(_unref(ArrowDownOutlined))
                              ]),
                              _createElementVNode("div", _hoisted_14, [
                                _hoisted_15,
                                _createElementVNode("div", _hoisted_16, _toDisplayString(expenseCount.value), 1)
                              ])
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_card, {
                  bordered: false,
                  class: "table-card"
                }, {
                  title: _withCtx(() => [
                    _createElementVNode("div", _hoisted_17, [
                      _hoisted_18,
                      _createVNode(_component_a_tag, { color: "blue" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(log_Conf.value.total) + " 条", 1)
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_a_table, {
                      class: "log-table-pc",
                      "data-source": log_data.value,
                      pagination: false,
                      "row-key": "id",
                      scroll: { x: 800 },
                      size: "small",
                      loading: log_loading.value,
                      bordered: "",
                      columns: logColumns
                    }, {
                      bodyCell: _withCtx(({ column, record }) => [
                        (column.key === 'log_act')
                          ? (_openBlock(), _createBlock(_component_a_tag, {
                              key: 0,
                              color: getLogTagColor(record.log_act)
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(getLogAct(record.log_act)), 1)
                              ]),
                              _: 2
                            }, 1032, ["color"]))
                          : (column.key === 'afterMoney')
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 1,
                                class: _normalizeClass(['money-text', record.afterMoney != undefined ? 'money-after' : 'money-none'])
                              }, _toDisplayString(record.afterMoney != undefined ? record.afterMoney : '无'), 3))
                            : (column.key === 'beforeMoney')
                              ? (_openBlock(), _createElementBlock("span", {
                                  key: 2,
                                  class: _normalizeClass(['money-text', record.beforeMoney != undefined ? 'money-before' : 'money-none'])
                                }, _toDisplayString(record.beforeMoney != undefined ? record.beforeMoney : '无'), 3))
                              : (column.key === 'operationMoney')
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 3,
                                    class: _normalizeClass(['money-text',
                                        record.operationMoney != undefined
                                            ? (record.log_act == 2 ? 'money-expense' : 'money-income')
                                            : 'money-none'
                                    ])
                                  }, _toDisplayString(record.operationMoney != undefined
                                            ? (record.log_act == 2 || record.log_act == 4
                                                ? '-' + record.operationMoney + '元'
                                                : '+' + record.operationMoney + '元')
                                        : '无'), 3))
                                : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["data-source", "loading"]),
                    (log_data.value && log_data.value.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(log_data.value, (record) => {
                            return (_openBlock(), _createBlock(_component_a_card, {
                              key: record.id,
                              class: "log-mobile-card",
                              bordered: false
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_20, [
                                  _createElementVNode("div", _hoisted_21, [
                                    _createElementVNode("span", _hoisted_22, "#" + _toDisplayString(record.id), 1),
                                    _createVNode(_component_a_tag, {
                                      color: getLogTagColor(record.log_act)
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(getLogAct(record.log_act)), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["color"])
                                  ]),
                                  _createElementVNode("span", _hoisted_23, _toDisplayString(record.add_time), 1)
                                ]),
                                _createElementVNode("div", _hoisted_24, [
                                  _createElementVNode("div", _hoisted_25, [
                                    _hoisted_26,
                                    _createElementVNode("span", _hoisted_27, _toDisplayString(record.log_desc), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_28, [
                                    _hoisted_29,
                                    _createElementVNode("span", {
                                      class: _normalizeClass(['money-text',
                                            record.operationMoney != undefined
                                                ? (record.log_act == 2 ? 'money-expense' : 'money-income')
                                                : 'money-none'
                                        ])
                                    }, _toDisplayString(record.operationMoney != undefined
                                                ? (record.log_act == 2 || record.log_act == 4
                                                    ? '-' + record.operationMoney + '元'
                                                    : '+' + record.operationMoney + '元')
                                            : '无'), 3)
                                  ]),
                                  _createElementVNode("div", _hoisted_30, [
                                    _hoisted_31,
                                    _createElementVNode("span", {
                                      class: _normalizeClass(['money-text', record.beforeMoney != undefined ? 'money-before' : 'money-none'])
                                    }, _toDisplayString(record.beforeMoney != undefined ? record.beforeMoney : '无'), 3)
                                  ]),
                                  _createElementVNode("div", _hoisted_32, [
                                    _hoisted_33,
                                    _createElementVNode("span", {
                                      class: _normalizeClass(['money-text', record.afterMoney != undefined ? 'money-after' : 'money-none'])
                                    }, _toDisplayString(record.afterMoney != undefined ? record.afterMoney : '无'), 3)
                                  ])
                                ])
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true),
                    ((!log_data.value || log_data.value.length === 0) && !log_loading.value)
                      ? (_openBlock(), _createBlock(_component_a_empty, {
                          key: 1,
                          class: "log-mobile-empty",
                          description: "暂无日志数据"
                        }))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_34, [
                      _createVNode(_component_a_pagination, {
                        current: log_Conf.value.currentPage,
                        "onUpdate:current": _cache[0] || (_cache[0] = ($event: any) => ((log_Conf.value.currentPage) = $event)),
                        "page-size": log_Conf.value.pageSize,
                        "onUpdate:pageSize": _cache[1] || (_cache[1] = ($event: any) => ((log_Conf.value.pageSize) = $event)),
                        "page-size-options": [10, 25, 50],
                        "show-size-changer": "",
                        "show-quick-jumper": "",
                        "show-total": (total) => `共 ${total} 条记录`,
                        total: log_Conf.value.total,
                        onChange: pageChange
                      }, null, 8, ["current", "page-size", "show-total", "total"])
                    ])
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})